class NoDataToExportError extends Error {
    constructor() {
        super('There is no data to export.');

        this.name = 'NoDataToExportError';
    }
}

export default NoDataToExportError;
